import axios from 'axios';
import {DOMAINS} from "../constants/DomainUrlConstants";

export const HEADER_DOMAIN_KEY = "X-Spot-Frontend-Domain";
export const HEADER_IDENTITY_KEY = "X-Spot-Identity";
export const NO_AUTHORIZED_IDENTITY = "not-authenticated";


export const REST_CONFIG_WWW_FORM_URLENCODED = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
};



const BackendRestClient = axios.create({
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
});

BackendRestClient.interceptors.request.use(config => {
    config.headers[HEADER_DOMAIN_KEY] = getDomain();
    return config;
}, error => Promise.reject(error));


export const getDomain = () => {
    const url: string = window.location.hostname;

    if (url.includes(DOMAINS.ABC.url)) {
        return DOMAINS.ABC.domain;
    } else if (url.includes(DOMAINS.VCP.url)) {
        return DOMAINS.VCP.domain;
    } else {
        return DOMAINS.CP.domain;
    }

};

export default BackendRestClient;
